var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamBadgePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0996 6.50879V12C21.0343 14.332 20.603 16.4502 19.2939 18.2969C18.0121 20.1049 15.8097 21.7581 12 23.0479C8.19032 21.7581 5.98787 20.1049 4.70605 18.2969C3.39698 16.4502 2.96575 14.332 2.90039 12V6.50879L12 1.04883L21.0996 6.50879ZM17.0996 8.77441V11.9443C17.0482 13.6033 16.7748 14.8749 16.04 15.9434C15.3349 16.9687 14.1283 17.9135 11.999 18.7842C9.87076 17.9141 8.6649 16.9686 7.95996 15.9434C7.2253 14.8748 6.95179 13.6032 6.90039 11.9443V8.77441L12 5.71387L17.0996 8.77441ZM20.9004 6.62305L20.4629 6.36133L12.4629 1.56152L12 1.2832L11.5371 1.56152L3.53711 6.36133L3.09961 6.62305V11.9854L3.10059 11.998C3.16358 14.2331 3.57028 16.3455 4.89453 18.207C6.2171 20.0661 8.37193 21.5598 11.7002 22.7363L12 22.8428L12.2998 22.7363C15.6281 21.5598 17.7829 20.0661 19.1055 18.207C20.4297 16.3455 20.8364 14.2331 20.8994 11.998L20.9004 11.9854V6.62305Z",
    fill: "#7F8585",
    stroke: "#7F8585",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBadgePlaceholder);
export default __webpack_public_path__ + "static/media/team_badge_placeholder.a2d06840d539ca1ac88617dbd1d982fd.svg";
export { ForwardRef as ReactComponent };